import { Fragment, useMemo } from 'react';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

import { AboutUsTemplate } from '../model';

export function StatsSection({ stats }: { stats: AboutUsTemplate['stats'] }) {
  return (
    <Box as='section'>
      <ContentContainer>
        <Flex
          bg='accent.sky.100'
          borderBottomLeftRadius='24px'
          borderBottomRightRadius='base'
          borderTopLeftRadius='base'
          borderTopRightRadius='24px'
          flexDirection={{ base: 'column', lg: 'row' }}
          gap='24px'
          justifyContent='space-between'
          p='32px 48px'
        >
          {stats.map((stat, i) => (
            <Fragment key={stat._id}>
              <Stat stat={stat} />
              {i !== stats.length - 1 && (
                <Box bg='white' height={{ base: '2px', lg: 'unset' }} width={{ base: '100%', lg: '2px' }} />
              )}
            </Fragment>
          ))}
        </Flex>
      </ContentContainer>
    </Box>
  );
}

function Stat({ stat }: { stat: AboutUsTemplate['stats'][number] }) {
  // Given values like: 16.9M+, 1.2K+, 90% - create 2 arrays, the first containing the numbers, and the second containing the rest
  const { numbers, rest } = useMemo(() => {
    const [number, ...restOfStat] = stat.title.split(/(M|K|%)/);

    return {
      numbers: number,
      rest: restOfStat.join(''),
    };
  }, [stat]);

  return (
    <Flex key={stat._id} flexDirection='column' gap='8px' width='200px'>
      <Heading as='div' color='blue.500' fontWeight='500' size='marketing-5xl'>
        {numbers}
        <Heading as='span' fontWeight='500' size='marketing-4xl'>
          {rest}
        </Heading>
      </Heading>
      <Text size='label'>{stat.text}</Text>
    </Flex>
  );
}
